import React, {useState} from 'react';
import { SimpleAccordion} from 'cdk-radial';

const UNDEFINED = 'undefined undefined';

const ConsentAccordion = ({data}) => {

    const [openPanels, setOpenPanels] = useState({});

  const handlePanelToggle = id => {
    const isOpen = openPanels[id];
    setOpenPanels({ ...openPanels,
      [id]: !isOpen
    });
  };

  const content = (data) => {
    return <div className='consent-body'>
        <div className ='consent-details'>
          <div className='consent-info consent-info-location'>Location</div> 
          <div className='consent-info consent-info-location'>Consented By</div>
          <div className='consent-info consent-info-date'>Date</div>
        </div>
        {
            data && data.map((item) => (
                <div className ='consent-details'>
                    <div className='consent-info consent-info-location'>{item.location}</div> 
                    <div className='consent-info consent-info-location'>{item?.name === UNDEFINED || !item?.name ? 'NA' : item?.name}</div>
                    <div className='consent-info consent-info-date'>{item.createdDate}</div>
                </div>
            ))
        }
    </div>;
  }

  const items = [{
    content: content(data),
    id: 'panel-1',
    title: 'Consent Details'
  }];
  return <SimpleAccordion items={items} onPanelToggle={handlePanelToggle} openPanels={openPanels} />;
  }

export default ConsentAccordion;